<div class="asset-fields">
  <div class="asset-fields__header">
    <h3 class="asset-fields__title">{{ 'core.asset_fields' | translate | uppercase }}</h3>
  </div>

  <p class="asset-fields__description">{{ 'info.asset_fields_description' | translate }}</p>

  <button
    type="button"
    class="btn btn-primary btn-block"
    (click)="onNewAssetField()"
    data-cy="new-asset-field"
  >
    <i class="ri-add-circle-line"></i>
    {{ 'button.new_asset_field' | translate }}
  </button>

  <div class="asset-fields__empty" *ngIf="!hasFields" data-cy="asset-fields-empty">
    {{ 'info.no_asset_fields' | translate }}
  </div>

  <table mat-table [dataSource]="assetFields" class="spotlab-table" *ngIf="hasFields">
    <ng-container matColumnDef="displayName">
      <th mat-header-cell *matHeaderCellDef>{{ 'label.display_name' | translate | uppercase }}</th>
      <td mat-cell *matCellDef="let field" class="display-name-cell">{{ field.displayName }}</td>
    </ng-container>

    <ng-container matColumnDef="fieldPath">
      <th mat-header-cell *matHeaderCellDef>{{ 'label.field_path' | translate | uppercase }}</th>
      <td mat-cell *matCellDef="let field" class="field-path-cell">{{ field.fieldPath }}</td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let field; let i = index" class="icon-cell">
        <button
          class="icon-button danger"
          type="button"
          (click)="onDeleteField(i)"
          data-cy="asset-field-delete"
        >
          <i class="ri-close-line"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let field; columns: columns"></tr>
  </table>
</div>
